import api from '@/api';
import {
  BankSlipRequestPdfResponse,
  ConfigBulletDetail,
  ConfigBulletRequest,
  DeleteBankSlipRequest,
  GenerateBulletRequest,
  GenerateBulletResponse,
  GenerateRemittanceAllRequest,
  GenerateRemittanceByWriteOffRequest,
  GenerateRemittanceRequest,
  IndividualTicketRequest,
  ListBillets,
  ListBilletsQuery,
  RemittanceReturnProtocolRequest,
  RemittanceReturnProtocolResponse,
  ReturnFileBankSlipRequest,
  ReturnFileBankSlipResponse,
  WriteOffBankSlipRequest,
  WriteOffBankSlipResponse,
} from './Boletos.types';
import { API_BASE_URL } from '..';
import { PageResult } from '@/core/request/PageResult';
import instance from '@/api/axiosInstance';
import { ACCESS_TOKEN } from '@/utils/user/constants';

const baseUrl = `${API_BASE_URL}/Boletos`;

export async function createConfigBulletByBankAccount(
  obj: ConfigBulletRequest,
) {
  const result = (await api.post(`${baseUrl}/convenio`, obj, null)) as unknown;

  return result;
}

export async function updateConfigBulletByBankAccount(
  obj: ConfigBulletRequest,
) {
  const result = (await api.put(`${baseUrl}/convenio`, obj, null)) as unknown;

  return result;
}

export async function getDetailBullet(
  bankAccountId: number,
  companyId?: number,
) {
  const result = (await api.get(
    `${baseUrl}/convenio?BankAccountId=${bankAccountId}&CompanyId=${companyId}`,
    {},
  )) as unknown as ConfigBulletDetail[];

  return result.length ? result[0] : null;
}

export async function generateByAccountReceivable(
  obj: GenerateBulletRequest,
): Promise<GenerateBulletResponse> {
  const result = (await api.post(`${baseUrl}`, obj, null)) as unknown;

  return result as GenerateBulletResponse;
}

export async function listBullets(params?: ListBilletsQuery) {
  const result = (await api.get(baseUrl, params)) as unknown;

  return result as PageResult<ListBillets>;
}

export async function generateRemmitanceBankSlip(
  params: GenerateRemittanceRequest,
) {
  const result = (await api.getReport(
    `${baseUrl}/remittance`,
    params,
    {},
  )) as unknown;

  return result as BlobPart;
}

export async function generateRemmitanceAllBankSlip(
  params: GenerateRemittanceAllRequest,
) {
  const result = (await api.getReport(
    `${baseUrl}/remittance-all`,
    params,
    {},
  )) as unknown;

  return result as BlobPart;
}

export async function bankSlipConsultPdf(bankSlipId: number) {
  const result = (await api.getReport(
    `${baseUrl}/${bankSlipId}/consult/bank-slip/pdf`,
    {},
    {},
  )) as unknown;

  return result as BlobPart;
}

export async function bankSlipRequestPdf(bankSlipId: number) {
  const result = (await api.post(
    `${baseUrl}/${bankSlipId}/request/bank-slip/pdf`,
    {},
  )) as unknown;

  return result as BankSlipRequestPdfResponse;
}

export async function deleteBankSlip(params: DeleteBankSlipRequest) {
  const result = (await api.remove(`${baseUrl}`, params, null)) as unknown;

  return result;
}

export async function fileReturnBankSlip(obj: ReturnFileBankSlipRequest) {
  const accessToken = localStorage.getItem(ACCESS_TOKEN);
  const formData = new FormData();

  formData.append('file', obj.file);
  formData.append('companyId', String(obj.companyId));

  const result = (await instance.post(
    `${baseUrl}/remittance/return`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${accessToken}`,
      },
    },
  )) as unknown;

  return result as ReturnFileBankSlipResponse;
}

export async function remittanceReturnProtocol(
  params: RemittanceReturnProtocolRequest,
) {
  const { protocol, ...values } = params;
  const result = (await api.get(
    `${baseUrl}/remittance/return/${protocol}`,
    values,
  )) as unknown;

  return result as RemittanceReturnProtocolResponse;
}

export async function writeOffBankSlip(params: WriteOffBankSlipRequest) {
  const result = (await api.post(
    `${baseUrl}/write-off`,
    params,
    null,
  )) as unknown;

  return result as WriteOffBankSlipResponse;
}

export async function generateRemmitanceByWriteOff({
  companyId,
  writeOffProtocol,
}: GenerateRemittanceByWriteOffRequest) {
  const result = (await api.getReport(
    `${baseUrl}/generate-remmitance/${writeOffProtocol}`,
    { companyId: companyId },
    {},
  )) as unknown;

  return result as BlobPart;
}

export async function individualTicketChange(obj: IndividualTicketRequest) {
  const result = (await api.put(
    `${baseUrl}/individual-ticket-change`,
    obj,
    null,
  )) as unknown;

  return result;
}

export async function bankSlipPublicPdf(token?: string) {
  const result = (await api.getReport(
    `${baseUrl}/generate/bank-slip/pdf/public`,
    { token: token },
  )) as unknown;

  return result as BlobPart;
}
